var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGroup44(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.351,
    height: 12.581,
    viewBox: "0 0 17.351 12.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 17.351,
    height: 12.581,
    fill: "#f49a56"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M13.828,12.581H3.523A3.53,3.53,0,0,1,0,9.054V3.526A3.53,3.53,0,0,1,3.523,0h10.3a3.529,3.529,0,0,1,3.523,3.527V9.054a3.529,3.529,0,0,1-3.523,3.526M3.523,1.768A1.756,1.756,0,0,0,1.775,3.527V9.054a1.756,1.756,0,0,0,1.748,1.759h10.3a1.755,1.755,0,0,0,1.748-1.759V3.527a1.755,1.755,0,0,0-1.748-1.759Z",
    transform: "translate(0 0)",
    fill: "#f49a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M12.36,6.949a.478.478,0,0,1,.221.641l-.005.011a.489.489,0,0,1-.216.21l-1.554.778-1.7.85a.5.5,0,0,1-.669-.211.482.482,0,0,1-.055-.218V5.748a.491.491,0,0,1,.5-.484h0a.494.494,0,0,1,.226.053l1.7.856Z",
    transform: "translate(-1.831 -1.166)",
    fill: "#f49a56",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup44);
export default __webpack_public_path__ + "static/media/icon-group-44.685a44e798e9ddd251076f791964d9de.svg";
export { ForwardRef as ReactComponent };